<template>
  <v-dialog v-model="dialog" persistent width="1200">
    <v-card>
      <v-card-title>
        {{ $t(title) }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" v-if="dialog">
            <CustomDeCreditNoteForm
              @change:item="updateItemFromResponse"
              :item="item"
              :module-actions="moduleActions"
              ref="form"
              :url-save="urlSave"
              :url-get="urlGet"
              :modify-document="true"
              @close="closeModal"
            ></CustomDeCreditNoteForm>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomDeCreditNoteForm from "./CustomDeCreditNoteForm.vue";
import NextMixinFormPage from "@/components/mixins/NextMixinFormPage";

export default {
  data() {
    return {
      dialog: false,
      title: "create_de-credit-note",
      itemId: null,
      urlGet: "api/v1/de-credit-note",
      urlSave: "api/v1/de-credit-note",
      pathBase: "/account/de-credit-note",
      pathCreate: "/account/de-credit-note/create",
    };
  },
  mixins: [NextMixinFormPage],
  components: { CustomDeCreditNoteForm },
  methods: {
    renderItem(itemId) {
      this.dialog = true;
      this.itemId = itemId;
      this.$nextTick(() => {
        this.manageEdit();
        this.breadcrumbsInit();
      });
    },
    closeModal() {
      this.item = null;
      this.$refs.form.clearForm();
      this.dialog = false;
      this.moduleActions = [];
    },
    itemToTitle() {
      if (this.item.consecutive_credit_note) {
        this.title = "Nota Crédito No " + this.item.consecutive_credit_note;
      }
    },
    manageEdit() {
      const id = this.itemId;
      this.loading = true;
      this.getItem(this.getUrlGet() + "/" + id)
        .then((data) => {
          this.item = data.item;
          this.moduleActions = data.module_actions;
          this.$refs.form.loadForm(JSON.parse(JSON.stringify(data.item)));
          this.loading = false;
          this.renderTitle();
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
};
</script>
